import { useState, useEffect, useRef } from "react";
import "../../Assets/Styles/Form/banquetReservation.scss";
import SelectSearchInput from "./../SelectSearch/index";
import axios from "axios";
import SubmitBtn from "../Buttons/submitBtn";
import SpecialRequest from "./specialRequest";
import AdvancePayment from "./advancePayment";
import AddDeleteTableRows from "./AddTable";
import ReactModal from "../Modals";
import NepaliDatePicker, { NepaliDate } from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';

const BanquetReservation = ({ customerID, token, inquiryData }) => {
  let baseUrl = process.env.REACT_APP_BASE_URL;

  const [hallList, setHallList] = useState([]);
  const [selectedHall, setSelectedHall] = useState(inquiryData?.hallName || "");
  const [outletList, setOutletList] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [showMessage, setShowMessage] = useState("");
  const [showPaymentAdd, setShowPaymentAdd] = useState(false);

  const [nepaliReservationDate, setNepaliReservationDate] = useState(new NepaliDate());
  const [nepaliForDate, setNepaliForDate] = useState(new NepaliDate(inquiryData?.reservationMiti));

  const parseNepaliDate = (value) => {
    try {
      let date;
      let nepaliDateStr = "";

      if (value && typeof value === 'object' && value.bsDate) {
        // Convert Nepali numerals to English digits
        const englishDate = value.bsDate.replace(/[०-९]/g, d => '०१२३४५६७८९'.indexOf(d));
        const [year, month, day] = englishDate.split('-').map(Number);
        date = new NepaliDate(year, month - 1, day);
        nepaliDateStr = date.format('YYYY-MM-DD');
      } else if (value instanceof NepaliDate) {
        nepaliDateStr = value.format('YYYY-MM-DD');
      } else if (typeof value === 'string') {
        nepaliDateStr = value;
      }

      return nepaliDateStr;
    } catch (error) {
      console.error("Error parsing Nepali date:", error);
      return null;
    }
  };

  const formattedReservationDate = parseNepaliDate(nepaliReservationDate);
  const formattedForDate = parseNepaliDate(nepaliForDate);

  useEffect(() => {
    if (token) {
      axios
        .post(`${baseUrl}/halls`, {
          token: `${token}`,
        })
        .then((response) => {
          setHallList(response.data);
        })
        .catch((error) => {
          // console.log(error)
        });
      axios
        .post(`${baseUrl}/outlets`, {
          token: `${token}`,
        })
        .then((response) => {
          setOutletList(response.data);
        })
        .catch((error) => {
          // console.log(error)
        });
    }
  }, [token]);

  const [values, setValues] = useState({
    NoOfPax: "",
    TimeSlot: "Lunch",
    SpecialRequest: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setValues({
      ...values,
      [id]: value,
    });
  };

  const [accessTable, setAccessTable] = useState(false);

  useEffect(() => {
    if (
      (nepaliForDate && selectedOutlet && selectedHall && values.TimeSlot) !==
      ""
    ) {
      setAccessTable(true);
    } else {
      setAccessTable(false);
    }
  }, [nepaliForDate, selectedOutlet, selectedHall, values.TimeSlot]);

  const [rowsData, setRowsData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const buttonRef = useRef(null);

  const addTableRows = () => {
    const rowsInput = {
      RateName: "",
      RateAmount: "",
      NoOfPax: values.NoOfPax,
      HallName: selectedHall,
    };
    setRowsData([...rowsData, rowsInput]);
    setShowTable(!showTable);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handleChange = (index, evnt) => {
    const { id, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][id] = value;
    setRowsData(rowsInput);
  };

  const [paymentData, setPaymentData] = useState([]);
  const [selected, setSelected] = useState("");

  const handleSelectChange = (event) => {
    setSelected(event.target.value);
    setShowPaymentAdd(true);
  };

  const addPaymentRows = () => {
    const paymentInput = {
      PaymentAmount: "",
      PaymentMode: selected,
    };
    setPaymentData([...paymentData, paymentInput]);
  };

  const deletePaymentRows = (index) => {
    const rows = [...paymentData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handlePaymentChange = (index, evnt) => {
    const { id, value } = evnt.target;
    const paymentInput = [...paymentData];
    paymentInput[index][id] = value;
    setPaymentData(paymentInput);
  };

  const [advancedPayment, setAdvancedPayment] = useState("");

  const handleAdvancedPayment = (event) => {
    setAdvancedPayment(event?.target?.value || "0");
  };

  const handleBanquetReservation = async () => {
    try {
      if (rowsData.length < 1) {
        setShowMessage(`There was an error. Please refresh the page and try again.`);
        handleShowModal();
        return;
      };

      if (!(rowsData[0].NoOfPax) || isNaN(rowsData[0].NoOfPax)) {
        setShowMessage(`Invalid number of pax.`);
        handleShowModal();
        return;
      }

      if (!(rowsData[0].RateAmount) || isNaN(rowsData[0].RateAmount)) {
        setShowMessage(`Invalid rate amount.`);
        handleShowModal();
        return;
      };

      if (advancedPayment && advancedPayment !== "0" && isNaN(advancedPayment)) {
        setShowMessage(`Invalid advance amount.`);
        handleShowModal();
        return;
      };

      if (advancedPayment && advancedPayment !== "0" && !selected) {
        setShowMessage(`Invalid advance payment mode.`);
        handleShowModal();
        return;
      }

      let paxcount = parseInt(rowsData[0].NoOfPax || 1);
      rowsData[0].RateAmount = `${parseFloat(rowsData[0]?.RateAmount)?.toFixed(2) || "0.00"}`;
      let rateAmount = parseFloat(rowsData[0]?.RateAmount)?.toFixed(2);
      let totalAmountafterTax = 1.13 * (rateAmount * paxcount);
      totalAmountafterTax = totalAmountafterTax?.toFixed(2);
      totalAmountafterTax = parseFloat(totalAmountafterTax);
      let advpaid = parseFloat(advancedPayment);

      if (advpaid > totalAmountafterTax) {
        setShowMessage(`Advance Payment amount cannot be greater than total amount (after tax). Total Amount after tax is ${totalAmountafterTax}`);
        handleShowModal();
        return;
      };

      if (advancedPayment === "0") {
        setAdvancedPayment("");
      }

      let response = await axios.post(`${baseUrl}/banquetregistration`, {
        tblbanquetReservation: {
          reservationMiti: formattedReservationDate,
          reservationMitiFor: formattedForDate,
          Outlet_Name: selectedOutlet,
          reservationState: "Started",
          TimeSlot: values.TimeSlot,
          customerID: customerID,
          advancePayment: advancedPayment,
          NoOfPax: values.NoOfPax,
          SpecialRequest: values.SpecialRequest,
          inquiry_id: inquiryData?.inquiry_id || ''
        },
        tblbanquetReservation_details: [{
          HallName: selectedHall,
          TimeSlot: values.TimeSlot,
        }],
        tblbanquetRate_details: rowsData,
        tblbanquetPayment_details: [{
          paymentDate: nepaliReservationDate,
          PaymentAmount: advancedPayment,
          PaymentMode: selected,
        }],
      });

      setShowMessage(response.data.result);
      handleShowModal();
    } catch (error) {
      setShowMessage(error.response?.data?.error || "An error occurred");
      handleShowModal();
    }
  };

  //Handle Modal open and close
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <section className="banquet-reservation">
      <ReactModal
        show={showModal}
        message={showMessage}
        buttonOne={"Ok"}
        buttonTwo={"Close"}
        handleTarget={handleCloseModal}
        handleClose={handleCloseModal}
      />
      <div className="banquet-reservation-headings">
        <h5>Banquet Reservation</h5>
        <small>Please fill out all the fields</small>
      </div>
      <div className="row banquet-reservation-info">
        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>Reservation Date:</label>
          <div className="nepali-calendar-container">
            <NepaliDatePicker
              value={nepaliReservationDate}
              placeholder="Select BS date"
              converterMode
              lang="en"
              onChange={(e) => setNepaliReservationDate(e)}
            />
          </div>
        </div>

        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>Reservation For Date:</label>
          <div className="nepali-calendar-container">
            <NepaliDatePicker
              value={nepaliForDate}
              placeholder="Select BS date"
              converterMode
              lang="en"
              onChange={(e) => setNepaliForDate(e)}
            />
          </div>
        </div>

        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>No of PAX:</label>
          <div>
            <input
              type="number"
              id="NoOfPax"
              placeholder="500"
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>Hall Selection:</label>
          <div>
            <SelectSearchInput
              defaultName={selectedHall}
              List={hallList}
              text={"Select Hall"}
              setSelectedItem={setSelectedHall}
            />
          </div>
        </div>
        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>Time Slot:</label>
          <div className="radio-type">
            <div className="radio-type">
              {["Lunch", "Dinner", "Both"].map(slot => (
                <div key={slot}>
                  <input
                    type="radio"
                    id="TimeSlot"
                    name="TimeSlot"
                    value={slot}
                    checked={values.TimeSlot === slot ||
                      (inquiryData?.timeSlot === slot)}
                    onChange={handleInputChange}
                  />
                  <label>{slot}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="reservation-info col-lg-4 col-md-4 col-sm-6">
          <label>Outlet Name:</label>
          <div>
            <SelectSearchInput
              defaultName={selectedOutlet}
              List={outletList}
              text={"Select Outlet"}
              setSelectedItem={setSelectedOutlet}
            />
          </div>
        </div>
      </div>

      <AddDeleteTableRows
        rowsData={rowsData}
        showTable={showTable}
        buttonRef={buttonRef}
        accessTable={accessTable}
        addTableRows={addTableRows}
        deleteTableRows={deleteTableRows}
        handleChange={handleChange}
        halls={selectedHall}
        timeSlot={values.TimeSlot}
      />
      <SpecialRequest handleInputChange={handleInputChange} />
      <AdvancePayment
        paymentData={paymentData}
        addPaymentRows={addPaymentRows}
        deletePaymentRows={deletePaymentRows}
        handlePaymentChange={handlePaymentChange}
        handleSelectChange={handleSelectChange}
        showPaymentAdd={showPaymentAdd}
        handleAdvancedPayment={handleAdvancedPayment}
        advancedPayment={advancedPayment}
      />
      <SubmitBtn event={"Save"} handle={handleBanquetReservation} />
    </section>
  );
};

export default BanquetReservation;